<template>
 <div class="uxmodal">
  <UIModal 
      v-if="showModal"
      id="alertModal" 
      @hide="cancel"
      :show-modal="showModal"
      :size="'sm'"
      :hide-footer="true"     
      :hide-title="false"
      @update:show-modal="showModal = $event"
      >
    <template v-slot:modal-title v-if="item">
      <div class="d-inline-block align-middle">
        <h5 class="d-inline-block mx-2 --gray">
          <span v-if="item.options&&item.options.icon" v-html="item.options.icon"></span>
          <i class="fa fa-times-circle-o mx-2" aria-hidden="true" v-else-if="item.type === error"></i>
          <i class="fa fa-exclamation-circle mx-2" aria-hidden="true" v-else-if="item.type === warning"></i>
          <i class="fa fa-info-circle mx-2" aria-hidden="true" v-else-if="item.type === info"></i>
          <i class="fa fa-check-circle mx-2" aria-hidden="true" v-else-if="item.type === confirmation"></i>
          <i class="fa fa-user-check mx-2" aria-hidden="true" v-else-if="item.type === consent"></i>
          <span class="capitalize">{{ (item.options && item.options.title) ? item.options.title:item.type}}</span>
        </h5>
      </div>
    </template>
    <template v-if="item">
      <div class="mx-5 form-group consent-action" v-if="item.type === consent">
        <div class="mx-2 mb-4" v-html="item.message"></div>
        <label>{{ $t('common.confirmByTyping') }} <span class="consent-text">{{ consentString }}</span> {{ $t('common.below') }}.</label>
        <UITextInput
          :placeholder="consentString"
          v-model="consentInput"
          name="consent"
          data-lpignore="true"
          @update:modelValue="consentError = null"
        />
        <span v-show="consentError" class="error">{{ consentError }}</span>

        <button type="button" class="btn btn-sm btn-blue mx-2 mt-4 mb-2 float-right" @click.stop.prevent="ok">{{ $t('common.buttons.confirm') }} {{consentString}}</button>
        <button type="button" class="btn btn-sm btn-light mx-2 float-right" @click.stop.prevent="cancel">{{item.options && item.options.cancelButton || $t('common.cancel')}}</button>
      </div>
      <div v-else>
        <div v-if="!isMessageInRawHTML" class="mx-2" :class="{'pb-2':item.type === prompt}">{{item.message}}</div>
        <div v-else v-html="item.message"></div>
        <div v-if="item.type === prompt">
          <label v-if="item.options && item.options.inputLabel" class="pb-2">{{item.options.inputLabel}}</label>
        <UITextInput
          :placeholder="consentString"
          v-model="consentInput"
          :type="item.options&&item.options.inputType?item.options.inputType:'text'"
          name="consent"
          data-lpignore="true"
          @update:modelValue="consentError = null"
        />
        </div>
        <div class="flex justify-end mt-4 py-2" style="width:100%" >
          <UIButton
            use="outline"
            v-if="item.type === confirmation"
            @click.stop.prevent="cancel"
          >{{item.options && item.options.cancelButton || $t('common.cancel')}}</UIButton>

          <UIButton
            use="tertiary"
            class="ml-2"
            @click.stop.prevent="ok"
          >
            {{item.options && item.options.okButton || $t('campaign.util.ok')}}
          </UIButton>
        </div>
      </div>
      <pre
        v-if="item.stack"
        class="my-4 mx-4"
        style="max-height:250px;overflow:auto;background:lightgray"
      >{{item.stack}}</pre>
    </template>
  </UIModal>
 </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import * as Ux from '@/util/ux_message'
import UIModal from '@/compatibility/modal/UIModal.vue'
import UIButton from '@/pmd/components/UIComponents/UIButton.vue'


export default defineComponent({
  components: {
    UIModal,
    UIButton
  },
  data() {
    return {
      item: undefined as Ux.UxMessage | undefined,
      consentInput: null as string,
      consentError: null as string,
      isMessageInRawHTML: false as boolean,
      showModal: false as boolean
    }
  },
  computed: {
    error() {
      return Ux.UxMessageType.ERROR
    },
    warning() {
      return Ux.UxMessageType.WARNING
    },
    info() {
      return Ux.UxMessageType.INFO
    },
    confirmation() {
      return Ux.UxMessageType.CONFIRMATION
    },
    consent() {
      return Ux.UxMessageType.CONSENT
    },
    prompt() {
      return Ux.UxMessageType.PROMPT
    },
    consentString() {
      return this.item.options && this.item.options.consentString || this.$t('common.buttons.delete')
    }
  },
  methods: {
    show(uxMessage: Ux.UxMessage, isMessageInRawHTML: boolean = false) {
      this.item = uxMessage
      this.isMessageInRawHTML = isMessageInRawHTML
      this.showModal = true
    },
    clear() {
      this.item = undefined
      this.consentInput = null
      this.consentError = null
    },
    async ok(){
      if (this.item?.type === this.consent) {
        if (!this.consentInput || this.consentInput.toLowerCase() !== this.consentString.toLowerCase()) {
          this.consentError = this.$t('campaign.util.pleaseTypeOrCancel', { consentString: this.consentString })
          return false;
        }
      }
      if(this.item?.type === this.prompt && this.item.options)
      this.item.options.returnInfo=this.consentInput
      this.item?.Ok();
      this.clear();
      this.showModal = false
    },
    cancel(){
        this.item?.Cancel();
        this.clear();
        this.showModal = false
    },
  }
})
</script>

<style scoped>
.consent-action {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.consent-text {
  color: #e93d3d;
}
</style>
